import Vue from 'vue';
import FlagIcon from 'vue-flag-icon';

Vue.use(FlagIcon);